import { Stack, Group, Text, Button, Paper, Title, Box } from '@mantine/core'
import { useMutation, useQuery } from '@apollo/client/react'
import CurrentUser from '../graphql/queries/CurrentUser'
import AcceptInvite from '../graphql/queries/AcceptInvite'
import DeclineInvite from '../graphql/queries/DeclineInvite'

export default function Invitations() {
    const { data } = useQuery(CurrentUser)
    const invites = data?.user?.invites

    const [acceptInvite, { loading: acceptInviteLoading }] = useMutation(AcceptInvite, {
        notifyOnNetworkStatusChange: true
    })

    const [declineInvite, { loading: declineInviteLoading }] = useMutation(DeclineInvite, {
        notifyOnNetworkStatusChange: true
    })

    async function accept(invite) {
        acceptInvite({ variables: { id: invite.id } })
    }

    async function decline(invite) {
        declineInvite({ variables: { id: invite.id } })
    }

    if (!invites || invites.length === 0) {
        return null
    }

    return (
        <Box>
            <Title order={5} c="gray.3" mb="xs" style={{ textAlign: 'left' }}>Invitations</Title>
            <Paper p="md" radius="md" withBorder style={{ background: 'rgba(255,255,255,0.05)' }}>
                <Stack gap="sm">
                    {invites.map((invite) => (
                        <Group
                            key={invite.id}
                            justify="space-between"
                            align="center"
                            p="xs"
                            style={{
                                background: 'rgba(99,102,241,0.1)',
                                borderRadius: '8px',
                                border: '1px solid rgba(99,102,241,0.2)'
                            }}
                        >
                            <Stack gap={4}>
                                <Text size="sm" fw={500}>{invite.room.name}</Text>
                                <Text size="xs" c="dimmed">From: {invite.issuer.username}</Text>
                            </Stack>
                            <Group gap="xs">
                                <Button
                                    size="xs"
                                    variant="light"
                                    color="green"
                                    onClick={() => accept(invite)}
                                    loading={acceptInviteLoading}
                                >
                                    Accept
                                </Button>
                                <Button
                                    size="xs"
                                    variant="light"
                                    color="red"
                                    onClick={() => decline(invite)}
                                    loading={declineInviteLoading}
                                >
                                    Decline
                                </Button>
                            </Group>
                        </Group>
                    ))}
                </Stack>
            </Paper>
        </Box>
    )
}

